import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const AdTypes = {
  List: lazyNamed(() => import('./containers/AdTypesList/index.tsx'), 'AdTypesList'),
  AdTypeHistory: lazyNamed(() => import('./containers/AdTypeHistory.tsx'), 'AdTypeHistory'),
};
